import { useRootStore } from 'stores/use-root-store';
import { useConfig } from 'config/use-config';
import { getHomeLink } from 'utils/url/url';

export const useGetHomeLink = (): string => {
  const petType = useRootStore((store) => store.petType);
  const { region } = useConfig();
  return getHomeLink({ petType, region });
};
